import general from "./general";

export default {
	general,
};



// WEBPACK FOOTER //
// ./src/face/nose/index.js